module.exports = __webpack_public_path__ + "img/tl-cd.d2483e88.svg";